(() => {
  function initArchive(root){
    if(!root || root.dataset.rpntInitialized === 'true') return;
    root.dataset.rpntInitialized = 'true';
    document.body.classList.add('rpnt-files-active');

    const workspace = root.querySelector('.workspace');
    const fileGrid = root.querySelector('.file-grid');
    const fileCards = [...root.querySelectorAll('.file-card')];
    const gridToggle = root.querySelector('#gridToggle');
    const listToggle = root.querySelector('#listToggle');
    const sortToggle = root.querySelector('#sortToggle');
    const filterChips = [...root.querySelectorAll('.filter-chip')];
    const sidebarFilters = [...root.querySelectorAll('[data-sidebar-filter]')];
    const visibleCount = root.querySelector('#visibleCount');
    const taskItems = root.querySelector('#taskItems');
    const taskbar = root.querySelector('#taskbar');
    const windowLayer = root.querySelector('#windowLayer');

    let zCounter = 60;
    let currentFilter = 'all';
    let currentSort = 'recent';
    let openSerial = 0;

    const openWindows = () => [...root.querySelectorAll('.fake-window[data-rpnt-window]')];
    const windowIsOpen = win => win.dataset.state === 'open' || win.dataset.state === 'minimized';

    function bringToFront(win){
      zCounter += 1;
      win.style.zIndex = zCounter;
      openWindows().forEach(w => w.classList.toggle('frontmost', w === win));
      renderDock();
    }

    function minimizeWindow(win){
      win.dataset.state = 'minimized';
      win.classList.remove('open');
      renderDock();
    }

    function closeWindow(win){
      try{ win.querySelectorAll('video').forEach(v => v.pause()); }catch(e){}
      win.remove();
      renderDock();
    }

    function restoreOrFocus(win){
      win.dataset.state = 'open';
      win.classList.add('open');
      bringToFront(win);
    }

    function renderDock(){
      if(!taskItems || !taskbar) return;
      taskItems.innerHTML = '';
      const wins = openWindows().filter(windowIsOpen);
      taskbar.classList.toggle('visible', wins.length > 0);
      wins.forEach(win => {
        const pill = document.createElement('div');
        pill.className = 'task-pill' + (win.classList.contains('frontmost') && win.dataset.state === 'open' ? ' active' : '');
        const label = win.dataset.label || 'OPEN FILE';
        pill.innerHTML = `<button class="task-open" type="button"></button><button class="task-close" type="button" aria-label="Close">×</button>`;
        pill.querySelector('.task-open').textContent = label;
        pill.querySelector('.task-open').addEventListener('click', () => restoreOrFocus(win));
        pill.querySelector('.task-close').addEventListener('click', e => { e.stopPropagation(); closeWindow(win); });
        taskItems.appendChild(pill);
      });
    }

    function positionWindow(win, type){
      openSerial += 1;
      const desktop = window.innerWidth > 760;
      let width = type === 'garment' ? 640 : (type === 'image' ? 520 : 620);
      let height = type === 'garment' ? 520 : (type === 'image' ? 430 : 430);
      if(!desktop){
        width = Math.max(300, window.innerWidth - 24);
        height = Math.min(520, Math.max(330, window.innerHeight - 110));
      }
      win.style.width = width + 'px';
      win.style.height = height + 'px';
      const maxLeft = Math.max(8, window.innerWidth - width - 8);
      const topbarH = root.querySelector('.topbar')?.offsetHeight || 76;
      const maxTop = Math.max(8, window.innerHeight - topbarH - height - 8);
      const drift = ((openSerial - 1) % 6) * 22;
      const left = desktop ? Math.min(maxLeft, Math.max(8, window.innerWidth * .27 + drift)) : 12;
      const top = desktop ? Math.min(maxTop, Math.max(10, 44 + drift)) : 14;
      win.style.left = left + 'px';
      win.style.top = top + 'px';
    }

    function makeDraggable(win){
      win.addEventListener('mousedown', () => bringToFront(win));
      win.querySelector('.close')?.addEventListener('click', e => { e.stopPropagation(); closeWindow(win); });
      win.querySelector('.minimize')?.addEventListener('click', e => { e.stopPropagation(); minimizeWindow(win); });

      const head = win.querySelector('.window-head');
      if(!head) return;
      let dragging = false, offX = 0, offY = 0;
      head.addEventListener('mousedown', e => {
        if(e.target.closest('button')) return;
        dragging = true;
        bringToFront(win);
        const r = win.getBoundingClientRect();
        offX = e.clientX - r.left;
        offY = e.clientY - r.top;
        document.body.style.userSelect = 'none';
      });
      const move = e => {
        if(!dragging) return;
        const topbarH = root.querySelector('.topbar')?.offsetHeight || 76;
        const w = win.offsetWidth, h = win.offsetHeight;
        let left = e.clientX - offX;
        let top = e.clientY - topbarH - offY;
        left = Math.max(0, Math.min(left, window.innerWidth - w));
        top = Math.max(0, Math.min(top, window.innerHeight - topbarH - h));
        win.style.left = left + 'px';
        win.style.top = top + 'px';
      };
      const up = () => { dragging = false; document.body.style.userSelect = ''; };
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
    }

    function initGarment(win){
      const stage = win.querySelector('[data-garment-stage]');
      const obj = win.querySelector('[data-garment-object]');
      const reset = win.querySelector('[data-reset-garment]');
      if(!stage || !obj) return;
      let rot = -18, scale = 1, dragging = false, startX = 0, startRot = 0;
      const update = () => obj.style.transform = `rotateX(-3deg) rotateY(${rot}deg) scale(${scale})`;
      stage.addEventListener('mousedown', e => { dragging = true; startX = e.clientX; startRot = rot; });
      window.addEventListener('mousemove', e => { if(!dragging) return; rot = startRot + (e.clientX - startX) * .55; update(); });
      window.addEventListener('mouseup', () => dragging = false);
      stage.addEventListener('wheel', e => { e.preventDefault(); scale = Math.max(.72, Math.min(1.48, scale - e.deltaY * .001)); update(); }, {passive:false});
      reset?.addEventListener('click', () => { rot = -18; scale = 1; update(); });
      update();
    }

    function openFromCard(card){
      if(card.dataset.status !== 'recovered'){
        card.classList.remove('denied');
        void card.offsetWidth;
        card.classList.add('denied');
        setTimeout(() => card.classList.remove('denied'), 650);
        return;
      }
      const id = card.dataset.blockId;
      let win = root.querySelector(`[data-rpnt-window="${CSS.escape(id)}"]`);
      if(win){ restoreOrFocus(win); return; }
      const tpl = root.querySelector(`#rpnt-template-${CSS.escape(id)}`);
      if(!tpl || !windowLayer) return;
      const fragment = tpl.content.cloneNode(true);
      win = fragment.querySelector('.fake-window');
      if(!win) return;
      win.dataset.rpntWindow = id;
      win.dataset.state = 'open';
      win.dataset.label = card.dataset.name || 'OPEN FILE';
      positionWindow(win, card.dataset.type);
      windowLayer.appendChild(fragment);
      win = root.querySelector(`[data-rpnt-window="${CSS.escape(id)}"]`);
      makeDraggable(win);
      if(card.dataset.type === 'garment') initGarment(win);
      win.classList.add('open');
      bringToFront(win);
      renderDock();
    }

    fileCards.forEach(card => card.addEventListener('click', () => openFromCard(card)));

    function matchesFilter(card, filter){
      if(filter === 'all') return true;
      if(filter === 'restricted') return ['restricted','locked'].includes(card.dataset.status);
      return card.dataset.type === filter;
    }

    function updateCounts(){
      const counts = {
        all: fileCards.length,
        video: fileCards.filter(c => c.dataset.type === 'video').length,
        image: fileCards.filter(c => c.dataset.type === 'image').length,
        garment: fileCards.filter(c => c.dataset.type === 'garment').length,
        restricted: fileCards.filter(c => ['restricted','locked'].includes(c.dataset.status)).length
      };
      root.querySelectorAll('[data-count-filter]').forEach(el => {
        const n = counts[el.dataset.countFilter] || 0;
        el.textContent = String(n).padStart(2,'0');
      });
    }

    function renderFiles(){
      const visible = fileCards.filter(card => matchesFilter(card, currentFilter));
      const hidden = fileCards.filter(card => !matchesFilter(card, currentFilter));
      let sorted = [...visible];
      if(currentSort === 'name') sorted.sort((a,b) => a.dataset.name.localeCompare(b.dataset.name));
      else if(currentSort === 'type') sorted.sort((a,b) => a.dataset.type.localeCompare(b.dataset.type) || a.dataset.name.localeCompare(b.dataset.name));
      else sorted.sort((a,b) => Number(a.dataset.order) - Number(b.dataset.order));
      sorted.forEach(card => { card.style.display = ''; fileGrid?.appendChild(card); });
      hidden.forEach(card => card.style.display = 'none');
      if(visibleCount) visibleCount.textContent = `${String(visible.length).padStart(2,'0')} FILES`;
      filterChips.forEach(chip => chip.classList.toggle('active', chip.dataset.filter === currentFilter));
      sidebarFilters.forEach(btn => btn.classList.toggle('active', btn.dataset.sidebarFilter === currentFilter));
    }

    function setView(mode){
      const list = mode === 'list';
      fileGrid?.classList.toggle('list-view', list);
      gridToggle?.classList.toggle('active', !list);
      listToggle?.classList.toggle('active', list);
    }

    filterChips.forEach(chip => chip.addEventListener('click', () => { currentFilter = chip.dataset.filter; renderFiles(); }));
    sidebarFilters.forEach(btn => btn.addEventListener('click', () => { currentFilter = btn.dataset.sidebarFilter; renderFiles(); }));
    gridToggle?.addEventListener('click', () => setView('grid'));
    listToggle?.addEventListener('click', () => setView('list'));
    sortToggle?.addEventListener('click', () => {
      const order = ['recent','name','type'];
      currentSort = order[(order.indexOf(currentSort) + 1) % order.length];
      sortToggle.textContent = `SORT // ${currentSort.toUpperCase()}`;
      renderFiles();
    });

    root.querySelector('#topPublicNode')?.addEventListener('click', () => {
      location.href = root.dataset.publicUrl || '/';
    });

    updateCounts();
    renderFiles();
    setView('grid');
    renderDock();

    // V14 secure-route / archive-mount intro.
    const overlay = root.querySelector('#archiveEntry');
    if(overlay){
      const kicker = overlay.querySelector('#entryKicker');
      const status = overlay.querySelector('#entryStatus');
      const topPhase = overlay.querySelector('#entryPhaseTop');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduced){
        overlay.classList.add('linked','ready');
        if(kicker) kicker.textContent = 'ARCHIVE MOUNTED';
        if(status) status.textContent = 'SECURE LINK ESTABLISHED';
        if(topPhase) topPhase.textContent = 'ACCESS GRANTED';
        setTimeout(() => overlay.classList.add('exit'), 450);
        setTimeout(() => overlay.remove(), 1100);
      }else{
        setTimeout(() => {
          if(kicker) kicker.textContent = 'VERIFYING SESSION ROUTE';
          if(status) status.textContent = 'ENCRYPTED LINK NEGOTIATED';
          if(topPhase) topPhase.textContent = 'ROUTE LOCKED';
        }, 900);
        setTimeout(() => {
          overlay.classList.add('linked');
          if(kicker) kicker.textContent = 'MOUNTING PRIVATE ARCHIVE';
          if(status) status.textContent = 'SESSION HANDOFF // ACCEPTED';
          if(topPhase) topPhase.textContent = 'NODE ACQUIRED';
        }, 1650);
        setTimeout(() => {
          overlay.classList.add('ready');
          if(kicker) kicker.textContent = 'ARCHIVE MOUNTED';
          if(status) status.textContent = 'SECURE LINK ESTABLISHED';
          if(topPhase) topPhase.textContent = 'ACCESS GRANTED';
        }, 2250);
        setTimeout(() => overlay.classList.add('exit'), 2850);
        setTimeout(() => overlay.remove(), 3500);
      }
    }
  }

  function initAll(){ document.querySelectorAll('.rpnt-files-page').forEach(initArchive); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', e => {
    const root = e.target.matches?.('.rpnt-files-page') ? e.target : e.target.querySelector?.('.rpnt-files-page');
    if(root) initArchive(root);
  });
})();
